import React from 'react'
import PropTypes from 'prop-types'
import Error from './form-input-error'

import Label from '../label'

//https://jurassix.gitbooks.io/docs-react-validation-mixin/content/examples/radio.html
class Radios extends React.Component {
    staticpropTypes = {
        label: PropTypes.string,
        className: PropTypes.string,
        name: PropTypes.oneOfType([
            PropTypes.number.isRequired,
            PropTypes.string.isRequired
        ]),
        value: PropTypes.string,
        options: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.oneOfType([
                    PropTypes.number.isRequired,
                    PropTypes.string.isRequired
                ]),
                name: PropTypes.oneOfType([
                    PropTypes.number.isRequired,
                    PropTypes.string.isRequired
                ]),
                value: PropTypes.oneOfType([
                    PropTypes.bool.isRequired,
                    PropTypes.number.isRequired,
                    PropTypes.string.isRequired
                ])
            })
        ).isRequired,
        errorStr: PropTypes.string,
        disabled: PropTypes.bool,
        onChange: PropTypes.func.isRequired
    }

    static defaultProps = {
        errorStr: 'app.error',
        name: new Date().getTime()
    }

    state = {
        options: this.props.options,
        selected: this.props.value
    }

    handleChange(elt) {
         return e => {
            const { onChange = e => Promise.resolve(e) } = this.props
            const promise = onChange(elt) || Promise.resolve(elt)

            !promise._state && this.setState({loading: true})
            promise.then && promise.then(
                selected => this.setState({loading: false, error: false, selected}),
                err => this.setState({loading: false, error: true})
            )
            .catch( e => this.setState({loading: false, error: true}));
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextState) {
        this.setState({disabled: nextProps.disabled})
    }

    render() {
        const {label, name, errorStr, value, className=false, disabled } = this.props;
        const {error=false, options=[], loading=false, selected} = this.state;

        return <div className={"form form-radios" + (className?' '+className:'')}>
            <Label>{label}</Label>
            <ul className={'form-values' + (error?' error':'')}>
                {options.map((elt, i) => <li key={name + '-' + i}>
                        {console.log('eeee', elt, selected, selected && (elt.id === selected.id))}
                   <input type='radio'
                        id={name + '-' + i}
                        name={name}
                        checked={selected && (elt.id === selected.id)}
                        disabled={disabled || loading}
                        onChange={this.handleChange(elt).bind(this)}/>
                    <label htmlFor={name + '-' + i} key={i}>
                        {elt.name}
                    </label>
                </li>)}
                <Error visible={error} message={errorStr} />
            </ul>
        </div>
    }
}

export default Radios;
